import '@vaadin/notification';
import './descope-notification-container';
import './descope-notification-card';
import { componentName, NotificationClass } from './NotificationClass';

customElements.define(componentName, NotificationClass);

export { NotificationClass, componentName };
